module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"settings":"Settings","properties":"Properties","rooms":"Rooms","profile":"Profile","prices":"Prices","paymentMethods":"Payment Methods"},"sl":{"settings":"Nastavitve","properties":"Nastanitve","rooms":"Sobe","profile":"Profil","prices":"Cene","paymentMethods":"Plačilna sredstva"}}')
  delete Component.options._Ctor
}
